<div class="slide-toggle-content">
  <input
    #inputEl
    type="checkbox"
    [checked]="!!value"
    [disabled]="!!disabled"
    [readonly]="!!readOnly"
    (change)="onCheckedChange()"
  />

  <div class="slide-toggle-bar"></div>

  <div class="slide-toggle-thumb"></div>
</div>

<div class="label" *ngIf="!!label" (click)="onLabelClick()">
  {{ label }}
</div>
